//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { UniversalPostType } from '@apis/universal-posts/universalPostsApiModel';
import { IMediaMetadata } from '@models/INetworkItem';
import { ITwitterFormState } from '@universal-scheduling/models/SchedulerPostDetailsModels';

export const DEFAULT_TWITTER_POST_DETAILS_FORM_STATE: ITwitterFormState = {
  postType: UniversalPostType.TwitterMediaPost,
  postNow: false,
};

export const TWITTER_POST_DETAILS_SMART_INPUT_USER_SEARCH_COUNT = 20;
export const MAX_TWEET_LENGTH = 280;
export const MAX_TWITTER_GALLERY_IMAGE_COUNT = 4;

// https://github.com/bvengineering/curalate-twitter-gateway-service/blob/master/server/src/main/scala/com/curalate/services/twitter_gateway/service/api/provider/ScheduledTweetVerifier.scala#L31
export const MAX_TWITTER_VIDEO_LENGTH = 140000; // 140s
export const MIN_TWITTER_MEDIA_WIDTH_PX = 4;
export const MIN_TWITTER_MEDIA_HEIGHT_PX = 4;
export const MAX_TWITTER_MEDIA_WIDTH_PX = 8192;
export const MAX_TWITTER_MEDIA_HEIGHT_PX = 8192;

export const isTwitterMediaTooSmall = (mediaMetadata: IMediaMetadata) => {
  return (
    mediaMetadata.width < MIN_TWITTER_MEDIA_WIDTH_PX ||
    mediaMetadata.height < MIN_TWITTER_MEDIA_HEIGHT_PX
  );
};

export const isTwitterMediaTooLarge = (mediaMetadata: IMediaMetadata) => {
  return (
    mediaMetadata.width > MAX_TWITTER_MEDIA_WIDTH_PX ||
    mediaMetadata.height > MAX_TWITTER_MEDIA_HEIGHT_PX
  );
};

export const TwitterPostDetailsFormFieldErrorText = {
  NoMediaOrText: 'Please add either media or text to this post.',
  TextTooLong: 'Please enter 280 characters or less.',
} as const;
